<script>
import {Bar} from 'vue-chartjs'

export default {
    name: 'bar',
    extends: Bar,
    props: ['data', 'unit', 'xFormat', 'yFormat', 'yMax', 'tooltipFormat'],
    mounted() {
        this.refreshGraph()
    },
    methods: {
        refreshGraph: function () {
            this.renderChart(
                {
                    labels: this.data.map(i => i.label),
                    datasets: [
                        {
                            data: this.data.map(i => i.value),
                            props: {},
                            backgroundColor: '#FFD200',
                        }
                    ]
                },
                {
                    legend: undefined,
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        intersect: false,
                        callbacks: {
                            label: (tooltipItem, data) => {
                                const value =  Number(tooltipItem.value)
                                if(this.tooltipFormat){
                                    return this.tooltipFormat(value)
                                } else {
                                    return (Number.isFinite(value) ? value.toLocaleString(undefined, {maximumFractionDigits: 2}) : '0') + (this.unit ? ' ' + this.unit : '')
                                }
                            }
                        }
                    },
                    elements: {
                        point: {
                            radius: this.data.length > 60 ? 0 : 3
                        }
                    },
                    interaction: {
                        mode: 'index',
                        intersect: false,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                padding: 10,
                                fontSize: 11,
                                max: this.yMax ? this.yMax : undefined,
                                callback: value => this.yFormat ? this.yFormat(value) : (Number(value).toLocaleString() + (this.unit ? ' ' + this.unit : ''))
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                padding: 10,
                                fontSize: 11,
                                callback: value => this.xFormat ? this.xFormat(value) : (Number(value).toLocaleString())
                            }
                        }]
                    },
                },
            );
        }
    },
    watch: {
        data: function () {
            this.refreshGraph()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/part/chart/bar.vue